/* Routing paths */
const routePathRoot: string = '/';
const routePathHome: string = '/index.html';
const routePathCalendars: string = '/index.html';
const routePathCalendar: string = '/calendar.html';
const routePathCalendarPage: string = '/page.html';
const routePathPhotoSets: string = '/photo-sets.html';
const routePathPhotoSet: string = '/photo-set.html';
const routePathPhotoSetPage: string = '/photo.html';
const routePathLocations: string = '/locations.html';
const routePathLocation: string = '/location.html';
const routePathCountries: string = '/countries.html';

/*
 * Export functions.
 */
export {
    routePathRoot,
    routePathHome,
    routePathCalendars,
    routePathCalendar,
    routePathCalendarPage,
    routePathPhotoSets,
    routePathPhotoSet,
    routePathPhotoSetPage,
    routePathLocations,
    routePathLocation,
    routePathCountries
}
